/**
 * Horizon adds `layout/theme.liquid` → `search-modal` (predictive search dialog) on every page.
 * KM header (`km_header_main`) already provides `role="search"` + `/search` — on mobile, focusing
 * the KM field could still surface the unused global modal (duplicate “legacy” search UI).
 *
 * Strip `#search-modal` on the storefront when KM header is present. Skip in the theme editor
 * so the modal remains available for editing/preview if needed.
 */
(function () {
  if (typeof document === 'undefined') return;
  if (document.documentElement.classList.contains('shopify-design-mode')) return;
  if (!document.querySelector('[data-km-header-main]')) return;

  function removeGlobalSearchModal() {
    document.getElementById('search-modal')?.remove();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', removeGlobalSearchModal, { once: true });
  } else {
    removeGlobalSearchModal();
  }
})();
